module.exports = __webpack_public_path__ + "static/media/triple-anvers.8495dab4.jpg";